import { useContext } from 'react';

import { UserContext } from 'app/context/UserContext/UserContext';
import type { User } from 'app/typings';
import { getNewExtranetUrl } from 'app/utils/extranet';

import { useExtranetHotelsList } from './data/core/extranet/hotel/useHotelsList';

function resolveHotelId(
  initialHotelId: number | null,
  user: User | undefined,
  hotelsList: { id: number }[] | undefined,
  isAdmin: boolean,
  isExtranet = false
): number | null {
  let resolvedHotelId = initialHotelId;

  const isAccessible =
    resolvedHotelId !== null &&
    (isAdmin || (user?.hotelIds?.includes(resolvedHotelId) ?? false));

  if (!isAccessible && user) {
    if (user.hotelIds?.length) {
      resolvedHotelId = user.hotelIds[0];
    } else if (hotelsList?.length && isAdmin) {
      resolvedHotelId = hotelsList[0].id;
    }

    if (resolvedHotelId && isExtranet) {
      const path = getNewExtranetUrl(resolvedHotelId);

      window.history.pushState({ path }, '', path);
    }
  }

  return resolvedHotelId;
}

export const useInitializeApp = (app: string, user?: User) => {
  const { data: hotelsList } = useExtranetHotelsList();
  const { isAdmin } = useContext(UserContext);

  if (app === 'extranet') {
    const urlParams = new URLSearchParams(window.location.search);
    const hotelId = urlParams.get('hotelId');
    const initialHotelId = hotelId ? parseInt(hotelId, 10) : null;

    return resolveHotelId(
      initialHotelId,
      user,
      hotelsList,
      isAdmin,
      app === 'extranet'
    );
  }

  if (app === 'builder') {
    const url = new URL(window.location.href);
    const match = url.pathname.match(/\/ext\/(\d+)/);
    const initialHotelId = match ? parseInt(match[1], 10) : null;

    return resolveHotelId(initialHotelId, user, hotelsList, isAdmin);
  }

  return null;
};
